import React, { useEffect, useState } from 'react'
import "./TrackOrderContainer.css"
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'
function TrackOrderContainer() {
  const [number, setNumber] = useState('')
    const { currentLocal } = useSelector((state) => state.currentLocal);

  const [show, setShow] = useState(false)
  const [alert, setAlert] = useState(null)


  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();
  const sendData = async (e) => {
    e.preventDefault();
    await axios
      .get(`https://nanosoft.technology/smile/api/orders`,

        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.access_token}`
          }
        })

      .then(async (res) => {
        
        const filteredArray = res.data.data.filter(item => item.order_no == number); 
       
        if (filteredArray.length !== 0) {
          navigate(`/order/${filteredArray[0].id}`)
        } else {
          setShow(true)
          setAlert('this track number not found')          

        }

      })
      .catch((error) => {
        // setShow(true)



      });
  }
  return (

    <section className='trackOrder_container'>
      <h3>{currentLocal.home.TrackOrder}</h3>
      <div className='trackOrder_box'><p>{currentLocal.home.OrderCode}</p>
        <div className="w-50 mb-3">
          <input
            value={number}
            onChange={(e) => setNumber(e.target.value)}
          />

        </div>
        <button onClick={sendData}>
          {currentLocal.home.enter}
        </button>
      </div>
    </section>
  )
}

export default TrackOrderContainer